/* Keep the model-comparison return link aligned with native Shopify options. */
(() => {
  'use strict';
  const models = ['my135', 'my139', 'my131b', 'ys35', 'cn69', 'my138b', 'my136b', 'my153b', 'my152b', 'my137b'];
  function sync(scope, detail) {
    if (detail?.form?.closest('[data-accessory-root]')) return;
    const link = scope?.querySelector('[data-pdp-compare-link]');
    const model = scope?.dataset.model;
    if (!link || !models.includes(model)) return;
    let product = detail?.product;
    if (!product) {
      try { product = JSON.parse(scope.querySelector('[data-product-json]')?.textContent || 'null'); }
      catch (_) { return; }
    }
    const id = String(detail?.variant?.id || scope.querySelector('[data-variant-select]')?.value || '');
    if (!product?.variants?.some(variant => String(variant.id) === id)) return;
    const url = new URL(link.href, location.origin);
    if (url.origin !== location.origin) return;
    url.searchParams.set('models', model + ',' + (model === 'my135' ? 'my139' : 'my135'));
    url.searchParams.set('return_model', model);
    url.searchParams.set('return_variant', id);
    link.href = url.pathname + url.search;
  }
  function init() { document.querySelectorAll('[data-ml-product-section]').forEach(scope => sync(scope)); }
  document.addEventListener('ml:variant-changed', event => sync(event.detail?.form?.closest('[data-ml-product-section]'), event.detail));
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
